import { Component, OnInit, Input, TemplateRef, ContentChild, ViewChild } from '@angular/core';
import { FormGroup, FormArray, AbstractControl, FormControl } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable, Subscription } from 'rxjs';
import { FormObjects } from '../../../../core/utilities/formObjects';
import { NdmsUtils } from '../../../../core/utilities/ndmsUtils';
import { TabsetComponent} from 'ngx-bootstrap/tabs';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'search-multi-select',
  templateUrl: './search-multi-select.component.html',
  styleUrls: ['./search-multi-select.component.scss']
})
export class SearchMultiSelectComponent implements OnInit {
  @Input() searchFormGroup: FormGroup;
  @Input() searchService: any;
  @Input() searchFnName: string;
  @Input() formGroupArray: FormArray;

  @Input() wizardFormGroup: FormGroup;
  @Input() wizardForm: TemplateRef<any>;

  @ContentChild('formResult') searchResultTemplate: TemplateRef<any>;
  @ViewChild('searchTabs') searchTabs: TabsetComponent;
  @ViewChild(ModalDirective) modal: ModalDirective;

  searchResults: any[] = [];
  selectedResults: any[] = [];
  subscriptions: Subscription[] = [];

  selectedResultsFormGroupArray: FormGroup[] = new Array<FormGroup>();

  modalRef: BsModalRef;

  isWizard: boolean;
  isWizardSearching: boolean;
  wizardIndex: number = 0;

  constructor(private modalService: BsModalService) { }

  private init() {
    if (this.wizardForm) {
      this.isWizard = true;
      this.isWizardSearching = true;
    }

    this.searchResults = [];
    this.selectedResults = [];
    this.subscriptions = []
    this.selectedResultsFormGroupArray = new Array<FormGroup>();
    this.wizardIndex = 0;
  }

  openModal() {
      this.modal.show();
  }

  onSearch() {
    let searchCriteria = this.searchFormGroup.value;
    searchCriteria.pageNumber = 0;

    (this.searchService[this.searchFnName](searchCriteria) as Observable<any>).subscribe((results) => {
      this.processSearchResults(results.model);
      this.searchTabs.tabs[0].active = true;
    });
  }

  ngOnInit() {
    this.init();

    this.modal.onHidden.subscribe(() => {
      this.init();
    })
  }

  onSelect(selectedResult) {
    if (!selectedResult.isSelected) {
      selectedResult.isSelected = true;
      this.selectedResults.push(selectedResult);
    }
    else {
      this.onRemove(selectedResult);
    }

  }

  onRemove(selectedResult) {
    selectedResult.isSelected = false;
    this.selectedResults.splice(this.selectedResults.findIndex((element: any) => {
      return element.id === selectedResult.id
    }), 1);
  }

  onCancel() {
    this.modal.hide()
  }

  onComplete() {
    if (this.isWizard) {
      this.isWizardSearching = false;
      this.selectedResultsFormGroupArray = this.selectedResults.map((result: any) => {
        let selectedResultFormGroup = new FormGroup({
          id: FormObjects.Data(result.id)
        });

        Object.keys(this.wizardFormGroup.controls).forEach(key => {
          let wizardFormGroupControl: FormControl = (<FormControl>this.wizardFormGroup.get(key));
          selectedResultFormGroup.addControl(key, new FormControl(wizardFormGroupControl.value, wizardFormGroupControl.validator));
        });

        return selectedResultFormGroup;
      });
    }
  }

  onWizardCancel() {
    this.isWizardSearching = true;
  }

  onWizardPrevious() {
    if (this.wizardIndex > 0) {
      this.wizardIndex--;
    }
  }

  private isWizardStepValid(): boolean {
    let currentFormGroup: FormGroup = this.selectedResultsFormGroupArray[this.wizardIndex];
    if(!currentFormGroup.valid) {
      NdmsUtils.touchAllFields(currentFormGroup);
      return false;
    }

    return true;
  }

  onWizardContinue() {
    if(!this.isWizardStepValid()) {
      return;
    }

    if (this.wizardIndex < this.selectedResults.length - 1) {
      this.wizardIndex++;
    }
  }

  onWizardComplete() {
    if(!this.isWizardStepValid()) {
      return;
    }

    let formValues = this.selectedResultsFormGroupArray.map((formGroup) => {
      return formGroup.value;
    });
  }

  private processSearchResults(results: any[]) {
    this.searchResults = results.map((value: any) => {
      return {
        id: value.key,
        data: value,
        isSelected: this.selectedResults.find((result) => {
          return result.id === value.key
        }) != null
      }
    });
  }
}
